function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.0639)",
  strokeMiterlimit: 10
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m7.4683 7.8197c0-1.9989 1.6314-3.6194 3.6446-3.6194h17.008c2.0132 0 3.6446 1.6204 3.6446 3.6194v14.477c0 1.9989-1.6314 3.6194-3.6446 3.6194h-17.008c-2.0132 0-3.6446-1.6204-3.6446-3.6194z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m11.165 4.1414h17.022c2.0097 0 3.6377 1.5815 3.6377 3.5328v4.0506h-24.297v-4.0506c0-1.9514 1.6279-3.5328 3.6377-3.5328z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m11.106 4.2003h17.022c2.0097 0 3.6377 1.6122 3.6377 3.6015v4.1293h-24.297v-4.1293c0-1.9893 1.6279-3.6015 3.6377-3.6015z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m30.976 25.129c0-2.622 2.3364-4.7483 5.2236-4.7483 2.8872 0 5.2236 2.1263 5.2236 4.7483s-2.3364 4.7483-5.2236 4.7483c-2.8872 0-5.2236-2.1263-5.2236-4.7483z",
  fill: "#fff",
  strokeWidth: 1.053
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m36.336 21.501c-1.8995 0-3.4381 1.4815-3.4381 3.3077 0 1.8271 1.5386 3.3077 3.4381 3.3077s3.4381-1.4805 3.4381-3.3077c0-1.8262-1.5386-3.3077-3.4381-3.3077zm-1.4531-8.0883h2.9727l0.85477 2.6609 2.5548 0.88793 2.4788-1.0921 2.0514 1.9791-1.2727 2.2516 0.98773 2.5251 2.6973 0.88698v2.7293l-2.6213 0.88698-1.0637 2.32 1.4151 2.5251-2.2699 1.9791-2.4788-1.2289-2.4788 1.0237-0.92125 2.4568h-2.9727l-0.92125-2.5251-2.2699-0.88698-2.6213 1.0921-1.985-1.9107 1.0637-2.5935-0.85477-2.1833-2.7637-0.95536v-2.6609l2.6213-0.95536 0.99723-2.3884-1.2822-2.5251 2.0609-1.9791 2.6213 1.1605 2.4788-0.95536z",
  fill: "#adb9ca",
  strokeWidth: 0.66667
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m36.336 21.501c-1.8995 0-3.4381 1.4815-3.4381 3.3077 0 1.8271 1.5386 3.3077 3.4381 3.3077s3.4381-1.4805 3.4381-3.3077c0-1.8262-1.5386-3.3077-3.4381-3.3077zm-1.4531-8.0883h2.9727l0.85477 2.6609 2.5548 0.88793 2.4788-1.0921 2.0514 1.9791-1.2727 2.2516 0.98773 2.5251 2.6973 0.88698v2.7293l-2.6213 0.88698-1.0637 2.32 1.4151 2.5251-2.2699 1.9791-2.4788-1.2289-2.4788 1.0237-0.92125 2.4568h-2.9727l-0.92125-2.5251-2.2699-0.88698-2.6213 1.0921-1.985-1.9107 1.0637-2.5935-0.85477-2.1833-2.7637-0.95536v-2.6609l2.6213-0.95536 0.99723-2.3884-1.2822-2.5251 2.0609-1.9791 2.6213 1.1605 2.4788-0.95536z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.053
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.59048 -.40272)",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, React.createElement("path", {
  className: "icon-primary",
  d: "m35.717 9.4274-4.03 1.164 8.18 6.744 3.39-10.218-4.27 1.235c-4.61-8.483-14.77-7.991-19.54-2.589-1.69 2.318 1.27 3.821 2.53 2.178 2.68-3.202 10.06-4.732 13.74 1.486z",
  fill: "#ecaec6",
  strokeWidth: 0.66667
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m35.717 9.4274-4.03 1.164 8.18 6.744 3.39-10.218-4.27 1.235c-4.61-8.483-14.77-7.991-19.54-2.589-1.69 2.318 1.27 3.821 2.53 2.178 2.68-3.202 10.06-4.732 13.74 1.486z",
  fill: "none"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.0639)"
}, React.createElement("g", {
  strokeMiterlimit: 10
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m2.6677 4.7071c0-2.0258 1.6195-3.668 3.6181-3.668h16.884c1.9986 0 3.6181 1.6422 3.6181 3.668v14.672c0 2.0258-1.6195 3.668-3.6181 3.668h-16.884c-1.9986 0-3.6181-1.6422-3.6181-3.668z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("g", {
  fill: "#adb9ca"
}, React.createElement("path", {
  className: "icon-primary",
  d: "m6.3054 1.0391h17.022c2.0097 0 3.6377 1.6535 3.6377 3.6935v4.2347h-24.297v-4.2347c0-2.0399 1.6279-3.6935 3.6377-3.6935z",
  fillRule: "evenodd"
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 7.5272,
  y: 11.725,
  width: 3.1239,
  height: 2.2914
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 7.704,
  y: 16.887,
  width: 2.8882,
  height: 1.9238
})), React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(2.1705 .42865)",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "m4.5971 3.9951c0-0.28118 0.21258-0.50926 0.47123-0.50926h15.001c0.25864 0 0.47123 0.22808 0.47123 0.50926v2.0378c0 0.28118-0.21258 0.50926-0.47123 0.50926h-15.001c-0.25864 0-0.47123-0.22808-0.47123-0.50926z",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m4.1084 0.6104h16.898c1.9951 0 3.6112 1.6535 3.6112 3.6935v4.2347h-24.121v-4.2347c0-2.0399 1.6161-3.6935 3.6112-3.6935z",
  fill: "none"
}))), React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(2.1705 .42865)",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m11.952 12.519h8.452",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m11.952 17.504h8.452",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("rect", {
  x: 5.5629,
  y: 11.502,
  width: 2.8293,
  height: 2.1006,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("rect", {
  x: 5.5335,
  y: 16.546,
  width: 2.8882,
  height: 1.9238,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
})));
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m36.417 28.178h6.2926v3.3402l11.913-6.6806-11.913-6.6806v3.3402h-6.2926z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  opacity: 0.99,
  strokeWidth: 1.0575
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m36.417 28.178h6.2926v3.3402l11.913-6.6806-11.913-6.6806v3.3402h-6.2926z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 8
});
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "icon-tertiary",
  cx: 36.16,
  cy: 24.876,
  r: 3.2945,
  fill: "#fff",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 8
});
var SvgMenuDataTriggers = function SvgMenuDataTriggers(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 55,
    height: 37,
    viewBox: "0 0 55 37",
    overflow: "hidden",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuDataTriggers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-data-triggers.48036d04.svg";
export { ForwardRef as ReactComponent };